import React, { useEffect } from 'react';

import { breakPoint } from '../../../../app/theme';
import { useSelection } from '../../../../core/contexts/selection.context';

import styles from './project-template-item.module.scss';
export enum ProjectTemplateType {
  Empty = 'empty',
  Corporate = 'corporate', // Demo
  Commercial = 'commercial',
  ShortFiction = 'short-fiction',
  Documentary = 'documentary',
  SocialMedia = 'social-media',
  Interview = 'interview',
  Event = 'event',
}

export enum ProjectTemplateCategory {
  Empty = 'Empty project',
  Corporate = 'Corporate',
  Commercial = 'Commercial',
  ShortFiction = 'Short Fiction',
  Documentary = 'Documentary',
  SocialMedia = 'Social Media',
  Interview = 'Interview',
  Event = 'Event',
}

type ProjectTemplateItemProps = {
  category: ProjectTemplateCategory;
  value: ProjectTemplateType;
  backgroundImage: string;
  badge?: 'Demo' | 'Template';
  subCategory?: string;
  defaultValue?: ProjectTemplateType;
  onSelect?: () => void;
};

export const ProjectTemplateItem: React.FC<ProjectTemplateItemProps> = ({
  category,
  backgroundImage,
  badge,
  value,
  defaultValue,
  subCategory,
  onSelect,
}) => {
  const { select, elements } = useSelection();

  useEffect(() => {
    if (defaultValue) {
      select(ProjectTemplateType.Commercial);
    }
  }, []);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    select(value);
    onSelect && onSelect();
  };

  return (
    <div
      className={styles['container']}
      onClick={handleClick}
      data-selected={elements.includes(value)}
    >
      <div
        className={styles['cover']}
        style={{ '--template-cover': `url(${backgroundImage})` } as React.CSSProperties}
      />

      {badge && <div className={styles['badge']}>{badge}</div>}

      <div className={styles['content']}>
        <div className={styles['header']}>
          <p className={styles['title']}>{category}</p>
          {subCategory && <span className={styles['subtitle']}>{subCategory}</span>}
        </div>
      </div>
    </div>
  );
};
